<div class="snackbar-content">
  <mat-spinner diameter="24" class="custom-spinner"></mat-spinner>
  <span>{{ data.message }}</span>
</div>